import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Helper } from '../../../shared/helpers/helper';
import { Router } from '@angular/router';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { User } from '../../../shared/models/user.model';
import { CompareWellsService } from '../../../shared/services/compare-wells.service';

@Component({
  selector: 'app-dashboard-wells',
  templateUrl: './dashboard-wells.component.html',
  styleUrls: ['./dashboard-wells.component.scss']
})
export class DashboardWellsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  // Paging
  pagingState = {
    page: 1,
    pageSize: 8,
    collectionSize: 10
  };

  listWells: any[] = [];

  loading: boolean = false;
  user: User;

  isService: boolean = false;
  isOperator: boolean = false;
  searchFormValues: any;

  constructor(
    private userAuthService: UserAuthService,
    private compareWellsService: CompareWellsService,
    private router: Router
  ) {
    this.user = this.userAuthService.getUserInfo();
  }

  ngOnInit() {
    if (this.user && this.user.companyType !== 'Service') {
      this.isService = true;
    }
    if (this.user && this.user.companyType !== 'Operator') {
      this.isOperator = true;
    }
    this.loadData();
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  wellDetails(item: any) {
    this.router.navigate(['pages', 'wells', `${item.wellId}`], {
      queryParams: {
        page: this.pagingState.page
      }
    });
  }

  loadData() {
    this.loading = true;
    this.subscriptions.push(this.compareWellsService.getListWell(this.searchFormValues, this.pagingState.page, this.pagingState.pageSize).subscribe(
      (res) => {
        if (res) {
          this.listWells = res.result.items;
          this.pagingState.collectionSize = res.result.totalCount;
        }
        this.loading = false;
      }, (error) => {
        this.loading = false;
      }
    ));
  }
  dataTable(page) {
    this.pagingState.page = page;
    this.loadData();
  }

  onSearchWells(eventData) {
    this.pagingState.page = 1;
    this.searchFormValues = eventData;
    this.loadData();
  }

  onSortWells(eventData) {
    this.loadData();
  }
}
